import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { DataService } from './context/data.service';
import { Constant } from '../../environments/constants';
import { Utils } from '../../utils/utils';
import * as fromModel from '../services/models/';
import { AppMonitoringService } from '../services/util/app-monitoring.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalAccountService {

  constructor(private http: HttpClient, private appMonitoringService: AppMonitoringService) { }

 
  getExternalAccountList(clientid){
    let url =    Constant.uri.eaList + clientid;
    return this.http.get(encodeURI(url), Utils.getHttpOptions());
  }

  getExternalAccountListByClientIdsAPI(clientids){
    let url =    Constant.uri.eaListByClientIds;
    return this.http.post(encodeURI(url), clientids, Utils.getHttpOptions());    
  }

  getExternalAccountListByClientIds(clientids, dataService: DataService){    
    if(!dataService.appData.ExternalAccounts || dataService.appData.ExternalAccounts['Error']) {
      this.getExternalAccountListByClientIdsAPI(clientids).subscribe(result=>{
          dataService.dispatchAction(fromModel.DATA_ACTION.EXTERNALACCOUNTS,"ExternalAccountService-getExternalAccountListByClientIds", result);
      }, err=>{
        dataService.dispatchAction(fromModel.DATA_ACTION.EXTERNALACCOUNTS,"ExternalAccountService-getExternalAccountListByClientIds", {Error: fromModel.ERRORCODE.APIERROR, ErrorDetails: JSON.stringify(err)});
        console.log("Error getting External Account-Hypothetical Details: " + JSON.stringify(err));      
        this.appMonitoringService.traceMsg("Error getting External Account-Hypothetical Details: ", JSON.stringify(err) , 'Error');
      });
    }    
  }
  


  getExternalAccountDetails(eaIds){
    
    return this.http.get<any>(Constant.uri.eanDetails + eaIds, Utils.getHttpOptions());  
  }

  getExternalAccountDetailsByEAIds(eaIds){
    
    let url =    Constant.uri.eanDetailsEAIds;
    return this.http.post(encodeURI(url), eaIds, Utils.getHttpOptions());  

    
  }
 

}